import { useRef } from 'react'
import { useDrag, useDrop } from 'react-dnd'
import { ItemTypes } from './ItemTypes.js'
import {Image, Label, Segment, Icon, Grid, Header, Popup} from 'semantic-ui-react';

const style = {
  backgroundColor: 'white',
  cursor: 'move',
}
export const Card = ({ id, description, contenido,text, titulo,index, moveCard, activo, onShowModal, handleClick, onVisible, contenidoView, onAcordionContenido, onEliminar, card }) => {
    console.log(card);
  const ref = useRef(null)
  const [{ handlerId }, drop] = useDrop({
    accept: ItemTypes.CARD,
    collect(monitor) {
      return {
        handlerId: monitor.getHandlerId(),
      }
    },
    hover(item, monitor) {
      if (!ref.current) {
        return
      }
      const dragIndex = item.index
      const hoverIndex = index
      // Don't replace items with themselves
      if (dragIndex === hoverIndex) {
        return
      }
      // Determine rectangle on screen
      const hoverBoundingRect = ref.current?.getBoundingClientRect()
      // Get vertical middle
      const hoverMiddleY =
        (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2
      // Determine mouse position
      const clientOffset = monitor.getClientOffset()
      // Get pixels to the top
      const hoverClientY = clientOffset.y - hoverBoundingRect.top
      // Only perform the move when the mouse has crossed half of the items height
      // When dragging downwards, only move when the cursor is below 50%
      // When dragging upwards, only move when the cursor is above 50%
      // Dragging downwards
      if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
        return
      }
      // Dragging upwards
      if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
        return
      }
      // Time to actually perform the action
      moveCard(dragIndex, hoverIndex)
      // Note: we're mutating the monitor item here!
      // Generally it's better to avoid mutations,
      // but it's good here for the sake of performance
      // to avoid expensive index searches.
      item.index = hoverIndex
    },
  })
  const [{ isDragging }, drag] = useDrag({
    type: ItemTypes.CARD,
    item: () => {
      return { id, index }
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  })
  const opacity = isDragging ? 0 : 1
  drag(drop(ref))
  
  /*
  <Icon size="large" color={activo?"grey":"teal"}  name={activo?"minus":"plus"} link onClick={()=>onAcordionContenido(id)}/>
  */
  return (
    <div ref={ref} style={{ ...style, opacity }} data-handler-id={handlerId}>
    
      
       <Segment basic ribbon style={{ background: "#E7F0EF"}} attached>

            <Grid>
                <Grid.Row columns="2" >
                    <Grid.Column width="13" only='computer tablet '>
                        <Label as='a'   ribbon style={{ background: "#B8D8D5"}} size="large">
                            {description+" - "+titulo}
                        </Label>          

                    </Grid.Column>

                    <Grid.Column width="13" only='mobile'>

                        <Label as='a'   ribbon style={{ background: "#B8D8D5"}} size="small">
                         {description+" - "+titulo}
                        </Label>          

                    </Grid.Column>   
      
                    <Grid.Column width="3" textAlign='right' verticalAlign="middle">
      
                        <Popup
                            trigger={
                                <Icon size="large" color="red"  name="trash" link onClick={()=>onEliminar(id)} />
                            }
                            content='Eliminar'
                        />      
                        <Popup
                            trigger={
                                    <Icon size="large" color="green"  name="pencil" link onClick={()=>onShowModal("Contenido",2,id)} />
                            }
                            content='Editar'
                        />            
                        {/*Aqui va el boton de expandir que no es requerido de moemnto en este nivel*/}
                    </Grid.Column>

                </Grid.Row>
            </Grid>
        </Segment>
      
         <Segment color="teal" attached >
               <Grid>
                    <Grid.Row columns="2" >
                    <Grid.Column width="13">
                    <Header as='h4'>

                        <Header.Content>
                        {contenidoView.titulo}

                         <Header.Subheader>
                           {contenidoView.descripcion+ " "}<br/>
                           Tipo de contenido:{card.tipoContenido+ " "}<br/>
                            {contenidoView.idTipo==28 && card.fechaInicioExamen!=null?
                                <><br/>Activo el día: {card.fechaInicioExamen.substring(0,10)} al {card.fechaTerminoExamen.substring(0,10)}</>                                    
                                :
                                ""
                            }<br/>
                                
                                
                            {contenidoView.idTipo==26 ||  contenidoView.idTipo==27 || contenidoView.idTipo==29?    
                                <>Archivo:<Label>{contenidoView.archivo}</Label></>
                            :
                                ""
                            }
                            
                            {contenidoView.url!=null?
                                    <>Archivo:<Label>{contenidoView.url}</Label></>
                            :
                                ""
                            }
                        </Header.Subheader>
                        </Header.Content>
                    </Header> 

                    </Grid.Column>    
                    <Grid.Column width="3" textAlign='right'>
                        {contenidoView.url!=null?

                                <Icon size="large" color={contenidoView.color} link onClick={()=>handleClick(contenidoView.url, contenidoView.id)} name={contenidoView.icon} />

                            :            

                                <Icon size="large" color={contenidoView.color} link onClick={()=>onVisible(contenidoView.id)} name={contenidoView.icon} />

                        }
                </Grid.Column>

            </Grid.Row>






            </Grid>

        </Segment>
            <br/>    
    </div>
  )
}

  